const UNCONFIRMED_FORWARD_KEY = "hhn.forward.unconfirmed";

interface UnconfirmedForward {
  contactCount: number;
  at: number;
}

/**
 * A forward that never came back acknowledged leaves a note behind, because
 * the message telling the user about it rarely survives: losing the connection
 * also raises the app-wide offline overlay, which reloads the page as soon as
 * the network returns and takes any dialog or toast with it.
 *
 * Deliberately holds no message content and no recipient names — only how many
 * chats were involved. There is nothing here worth protecting if the machine is
 * shared.
 */
export function recordUnconfirmedForward(contactCount: number): void {
  try {
    const notice: UnconfirmedForward = { contactCount, at: Date.now() };
    localStorage.setItem(UNCONFIRMED_FORWARD_KEY, JSON.stringify(notice));
  } catch {
    // Private mode or quota: the in-app message is still shown, it just will
    // not outlive a reload.
  }
}

/** Reads the note and removes it, so the user is told exactly once. */
export function consumeUnconfirmedForward(): UnconfirmedForward | null {
  try {
    const raw = localStorage.getItem(UNCONFIRMED_FORWARD_KEY);
    localStorage.removeItem(UNCONFIRMED_FORWARD_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as UnconfirmedForward;
    return typeof parsed?.contactCount === "number" ? parsed : null;
  } catch {
    return null;
  }
}
